import { Injectable } from '@angular/core';
import { Functions, httpsCallable } from '@angular/fire/functions';
import { createFunctionResult, FUNCTION_RESULT_STATUS, FunctionResult, IObjectKey, isObjectKey } from '@nova/common-interfaces';
import { FUNCTION_NAME, IPayments } from '@rfm/shared-interfaces';
import { CommonService } from '../../../../lib/services/index.mjs';

@Injectable({
  providedIn: 'root',
})
export class PaymentService extends CommonService<IPayments, IObjectKey> {
  public override deleteFunctionName: FUNCTION_NAME = FUNCTION_NAME.FINANCIAL_PAYMENT_REMOVE;
  public override insertFunctionName: FUNCTION_NAME = FUNCTION_NAME.FINANCIAL_PAYMENT_INSERT;
  public override mergeFunctionName:  FUNCTION_NAME = FUNCTION_NAME.FINANCIAL_PAYMENT_MERGE;
  public override updateFunctionName:  FUNCTION_NAME = FUNCTION_NAME.FINANCIAL_PAYMENT_UPDATE;
  public override getAllFunctionName:  FUNCTION_NAME = FUNCTION_NAME.FINANCIAL_PAYMENT_GETALL;
  public override getFunctionName:  FUNCTION_NAME = FUNCTION_NAME.FINANCIAL_PAYMENT_GET;
  public override getKeysFunctionName:  FUNCTION_NAME = FUNCTION_NAME.FINANCIAL_PAYMENT_GETKEYS;
  public getByCustomerFunctionName: FUNCTION_NAME = FUNCTION_NAME.FINANCIAL_PAYMENT_GETBYCUSTOMER;
  public addPaymentIntentFunctionName: FUNCTION_NAME = FUNCTION_NAME.FINANCIAL_PAYMENT_ADDPAYMENTINTENT;

  constructor(functions: Functions) {
    super(functions);
  }

  public async addPaymentIntent(intent_id: string, customer_id: IObjectKey): Promise<FunctionResult<IPayments>> {
    this.isLoading(true);

    return new Promise<FunctionResult<IPayments>>((resolve, reject) => {
      const callable = httpsCallable<any, FunctionResult<IPayments>>(
        this.functions,
        this.addPaymentIntentFunctionName.toString()
      );
      callable({"intent_id" : intent_id, "customer": customer_id})
        .then(
          (result) => {
            console.debug("Result", result.data);
            resolve(result.data);
          },
          (error) => {
            console.error(error);
            reject(createFunctionResult<IPayments[] | null>(FUNCTION_RESULT_STATUS.ERROR, null));
          }
        )
        .finally(() => {
          this.isLoading(false);
        });
    });
  }
    public async getByCustomer(key: IObjectKey | string): Promise<FunctionResult<IPayments[]>> {
    this.isLoading(true);

  let myId = "";
    if (isObjectKey(key)) {
      console.log("service-get isObjectKey", key);
      myId = (key as IObjectKey).id;
    } else {
      myId = key as string;
    }

    return new Promise<FunctionResult<IPayments[]>>((resolve, reject) => {
      const callable = httpsCallable<IObjectKey | string, FunctionResult<IPayments[]>>(
        this.functions,
        this.getByCustomerFunctionName.toString()
      );
      callable(myId)
        .then(
          (result) => {
            console.debug("Result", result.data);
            resolve(result.data);
          },
          (error) => {
            console.error(error);
            reject(createFunctionResult<IPayments[] | null>(FUNCTION_RESULT_STATUS.ERROR, null));
          }
        )
        .finally(() => {
          this.isLoading(false);
        });
    });
  }
}
